export default __webpack_public_path__ + "images/plot-type-area.0802876deab84f33c43c93084bf9ab6c.svg";